/**
 * ResponsavelGrupoParceiroCollection
 *
 * @author Thacryba
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelGrupoParceiro} from '@/model/resource/ResponsavelGrupoParceiro'

@HttpExclude()
export class ResponsavelGrupoParceiroCollection extends PageCollection<
  ResponsavelGrupoParceiro
> {
  constructor() {
    super(ResponsavelGrupoParceiro)
  }

  async removeResponsavelGrupoParceiro(id1: number, id2: number) {
    return await Request.post(
      `/admin/responsavel-grupo-parceiro/remove/${id1}/${id2}`
    )
      .name('removeResponsavelGrupoParceiro')
      .asNumber()
      .getData()
  }

  async listIdsGrupoParceiro() {
    return await Request.get(`/admin/responsavel-grupo-parceiro/list-ids`, {
      params: this.params,
    })
      .name('listResponsavelGrupoParceiro')
      .asArrayOf(this)
      .getData()
  }
}
